import {axiosInstance, esputnikTracker, eventEmitter} from './common/baseData';

import React, {useState, useEffect, useRef} from 'react';
import ReactDOM from 'react-dom';
import queryString from 'query-string';
import Breadcrumbs from './components/breadcrumbs/Breadcrumbs';
import Title from './components/categoryPage/title/Title';
import Banner from './components/categoryPage/banner/Banner';
import SectionDescription
  from './components/categoryPage/sectionDescription/SectionDescription';
import FilterTags from './components/categoryPage/filterTags/FilterTags';
import FilterCloud from './components/categoryPage/filterCloud/FilterCloud';
import SubSectionList
  from './components/categoryPage/subSectionList/SubSectionList';
import Filter from './components/categoryPage/filter/Filter';
import ProductList from './components/productList/ProductList';
import SeoText from './components/seoText/SeoText';
import Faq from './components/faq/Faq';
import PriceTable from './components/priceTable/PriceTable';
import CreditTable from './components/creditTable/CreditTable';
import Shops from './components/shops/Shops';
import Reviews from './components/categoryPage/reviews/Reviews';
import Viewed from './components/categoryPage/viewed/Viewed';
import Articles from './components/categoryPage/articles/Articles';
import Pagination from './components/categoryPage/pagination/Pagination';
import Sorting from './components/categoryPage/sorting/Sorting';
import RelatedLinks from './components/categoryPage/relatedLinks/RelatedLinks';
// TODO Просмотренные товары

// TODO OLD перенести стили в компоненты и удалить подключение
import './catalog/style.css';
import './catalog/filter/style.css';
import './pagenavigation/style.css';
import './catalog/offers-list/colors.css';
import {decode} from 'html-entities';
import SelectionBlock
  from './components/categoryPage/selectionBlock/SelectionBlock';
import {createRoot} from 'react-dom/client';
import Layout from './Componentsv2/Layout/Layout';
// TODO OLD

let appRootNode = document.getElementById('app-root');

if (appRootNode) {
  let sortingParams = window.sortingParams ? {
    options: window.sortingParams['sortValues'],
    messages: window.sortingParams['messages'],
  } : {};

  let props = {
    filter: window.filterParams,
    productList: window.sectionItemListParams,
    navParams: window.sectionItemNavParams || {},
    faqParams: window.faqListParams || {},
    priceTable: window.priceTableParams || {},
    creditTable: window.creditTableParams || {},
    banner: window.bannerData || {},
    sectionDescription: window.sectionDescriptionParams || {},
    sortingParams: sortingParams,
    subSectionList: window.subSectionList || [],
    relatedLinks: window.relatedLinks || [],
    filterCloud: window.categoryFilterCloud || [],
    regionShopsParams: window.regionShops ||
        {title: '', shops: [], messages: {}},
    reviews: window.sectionReviews || {products: []},
    productViewed: window.productViewed || {itemsList: []},
    categoryNewsParams: window.categoryNewsParams || {},
  };

  //console.info('base props', props);

  // Init App
  const productListApp = createRoot(appRootNode);
  productListApp.render(
    <Layout page={'Section'}>
      <ProductListApp {...props}/>
    </Layout>);
}

/**
 * Renders the product list app with the given props
 *
 * @param {object} props - The props for the ProductListApp component
 * @param {object} [props.priceTable={}] - The price table object
 * @param {object} [props.creditTable={}] - The price table object
 * @param {object} [props.productListParams={}] - The product list parameters
 * @param {string|null} [props.productListParams.sectionDescription=null] - The section description
 * @param {object} [props.faqParams={}] - The FAQ parameters
 * @param {array} [props.productListParams.sectionPath=[]] - The section path
 * @param {object} [props.productListParams.titleBlockParams={}] - The title block parameters
 * @param {string} [props.productListParams.title=''] - The section title
 * @param {object} [props.productListParams.rating={}] - The rating object
 * @param {object} [props.productListParams.reviews={}] - The reviews object
 * @param {number|null} [props.productListParams.totalProductCount=null] - The total product count
 * @param {object} [props.banner={}] - The banner object
 * @param {object} [props.sectionDescription={}] - The section description object
 * @param {array} [props.subSectionList=[]] - The sub-section list
 * @param {object} [props.regionShopsParams={}] - The region shops parameters
 * @param {object} [props.reviews={}] - The reviews object
 * @param {object} [props.categoryNewsParams={}] - The category news parameters
 * @returns {void}
 */
function ProductListApp(props) {
  let catalogNode = document.querySelector('.catalog-holder');

  const [state, setState] = useState({
    priceTable: props.priceTable || {},
    creditTable: props.creditTable || {},
    productListParams: props.productList || {},
    seoText: props.productList &&
    props.productList.hasOwnProperty('sectionDescription') &&
    typeof props.productList.sectionDescription === 'string'
        ? props.productList.sectionDescription
        : null,
    faqParams: props.faqParams || {},
    breadcrumbs: props.productList &&
    props.productList.hasOwnProperty('sectionPath')
        ? props.productList.sectionPath
        : [],
    titleBlockParams: {
      title: props.productList &&
      props.productList.hasOwnProperty('sectionTitle')
          ? props.productList.sectionTitle
          : '',
      rating: props.productList &&
      props.productList.hasOwnProperty('rating')
          ? props.productList.rating
          : {},
      reviews: props.productList &&
      props.productList.hasOwnProperty('reviews')
          ? props.productList.reviews
          : {},
    },
    banner: props.banner || {},
    filterCloud: props.filterCloud || [],
    sectionDescription: props.sectionDescription || {},
    subSectionList: props.subSectionList || [],
    relatedLinks: props.relatedLinks || [],
    regionShopsParams: props.regionShopsParams || {},
    reviews: props.reviews,
    productViewed: props.productViewed,
    categoryNewsParams: props.categoryNewsParams || {},
    catalogHeight: catalogNode.clientHeight
  });

  const [totalProductsCount, setTotalProductsCount] = useState(
      props.productList &&
      props.productList.hasOwnProperty('totalProductCount')
          ? props.productList.totalProductCount
          : null);

  // связка с элементом каталога
  const catalogRef = useRef();

  // базовые параметры и состояние сортировки
  const [sortState, setSortState] = useState(null);
  const [sortParams, setSortParams] = useState(props.sortingParams || {});

  const [filterParams, setFilterParams] = useState(props.filter || {});

  const [filterTags, setFilterTags] = useState(props.filter &&
  props.filter.hasOwnProperty('selectedFilters')
      ? props.filter.selectedFilters
      : []);

  // базовое количество на странице и измененное состояние
  const [pageSize, setPageSize] = useState(null);

  // показ новостей категории
  const [isCategoryNewsRendered, setCategoryNewsRendered] = useState(false);

  const [navParams, setNavParams] = useState({
    firstPage: Number(props.navParams.firstPageNumber) || 1,
    lastPage: Number(props.navParams.lastPageNumber) || 1,
    page: Number(props.navParams.currentPageNumber) || 1,
    countPages: Number(props.navParams.countPages) || 1,
    savePage: props.navParams.savePage,
    productsCount: Number(props.navParams.countItems) || null,
    limit: Number(props.navParams.countPageItems) || 24,
  });

  const [seoParams, setSeoParams] = useState({});

  // набор мета данных страницы с обновленными данными
  const [metaParams, setMetaParams] = useState(null);

  const navMessages = props.navParams.messages || {};

  const [selectedFilterPath, setSelectedFilterPath] = useState(null);

  // признак использования фильтра
  const [isFilterUsed, setIsFilterUsed] = useState(
      filterTags.filterList &&
      Object.keys(filterTags.filterList).length > 0,
  );

  // признак необходимости обновлени данных по товарам после применения фильтров
  // используется в сценарии работы мобильной версии фильтра
  const [needUpdating, setNeedUpdating] = useState(false);

  // состояние открытия / закрытия мобильного фильтра
  const [filterOpened, setFilterOpened] = useState(false);

  const [clientWidth, setClientWidth] = useState(
      window.document.documentElement.clientWidth);

  useEffect(() => {
    window.addEventListener('popstate', event => (onPopState(event)));
    return () => {
      window.removeEventListener('popstate', event => (onPopState(event)));
    }
  }, []);

  useEffect(() => {
    window.history.replaceState({url: window.location.href}, null, window.location.href);
  }, []);

  /**
   * Обновление при resize страницы
   */
  useEffect(() => {
    // установка ширины экрана клиента
    window.addEventListener('resize',
        event => setClientWidth(window.document.documentElement.clientWidth));
    return () => {
      window.removeEventListener(
          'resize',
          event => setClientWidth(window.document.documentElement.clientWidth),
      );
    };
  }, []);

  /**
   * Обработка смены meta данных
   */
  useEffect(() => {
    // пропускаем стартовое состояние
    if (metaParams === null || typeof metaParams !== 'object') return;

    for (let metaKey in metaParams) {
      let metaNode = document.querySelector(`meta[name="${metaKey}"]`);
      if (!metaNode) continue;
      metaNode.content = decode(metaParams[metaKey]);
    }

    if (metaParams.hasOwnProperty('title')) {
      let metaNode = document.querySelector(`title`);
      metaNode.textContent = decode(metaParams.title);
    }

    // обновление описания в сео блоке
    setState(prevState => ({
      ...prevState,
      seoText: metaParams.hasOwnProperty('section-description') ? decode(metaParams['section-description']) : ''
    }));

    console.info('metaParams', metaParams);
  }, [metaParams]);

  /**
   * Обработка показа новостей
   */
  useEffect(() => {
    // Проверяем условие и устанавливаем isCategoryNewsRendered в true, если условие выполняется
    if (
        !isFilterUsed &&
        state.categoryNewsParams &&
        Object.keys(state.categoryNewsParams).length > 0 &&
        Object.keys(state.productListParams.itemsList).length === 0
    ) {
      setCategoryNewsRendered(true);
    }
  }, [
    isFilterUsed,
    state.categoryNewsParams,
    state.productListParams.itemsList]);

  /**
   * Обработка изменения выбранных фильтров
   */
  useEffect(() => {
    setIsFilterUsed(
        filterTags.filterList &&
        Object.keys(filterTags.filterList).length,
    );
  }, [filterTags]);

  /**
   * Обработка события работы с фильтром
   */
  useEffect( () => {
    if (selectedFilterPath === null || typeof selectedFilterPath !==
        'string') return;

    selectedFilterProcessing()
  }, [selectedFilterPath]);

  /**
   * Обработка изменения состояния сортировки
   */
  useEffect( () => {
    // пропускаем стартовое состояние
    if (sortState === null) return;

    changedSortProcessing();
  }, [sortState]);

  /**
   * Обработка изменения состояния количества товаров на странице
   */
  useEffect( () => {
    // пропускаем стартовое состояние
    if (isNaN(pageSize) || pageSize === null || Number(pageSize) <= 0) return;
    //console.info('onPageSizeChange', pageSize);

    changedPageSizeProcessing();
  }, [pageSize]);

  async function changedPageSizeProcessing() {
    // формирование нового url
    let smartUrl = `${window.location.pathname}${prepareQueryString(
      {count: pageSize})}`;

    // обновляем историю
    updateBrowserHistory(smartUrl);

    // перезагрузка списка товаров
    await refreshProducts(
      filterParams.globalFilter,
      state.productListParams.sectionCode,
      1,
      pageSize,
      seoParams,
    );
  }

  async function changedSortProcessing() {
    // option.sort, option.order, option.queryString
    let currentSortParams = Object.assign({}, sortParams);

    // снимаем текущую активности и устанавливаем новую
    currentSortParams.options.forEach(option => {
      if (option.active && option.label !== sortState.label) {
        option.active = false;
      } else if (option.label === sortState.label) {
        option.active = true;
      }
    });

    // подготоваливаем url
    let querySort = typeof sortState.sort === 'string' &&
    sortState.sort.length ? sortState.sort : null;
    let queryOrder = typeof sortState.order === 'string' &&
    sortState.order.length ? sortState.order : null;

    let stringifiedQueryString = prepareQueryString(
      {sort: querySort, order: queryOrder},
    );

    // формирование нового url
    let smartUrl = `${window.location.pathname}${stringifiedQueryString}`;

    // обновляем историю
    updateBrowserHistory(smartUrl);

    // перезагрузка списка товаров
    await refreshProducts(
      filterParams.globalFilter,
      state.productListParams.sectionCode,
      1,
      navParams.limit,
      seoParams,
    );

    // сохраняем состояние
    setSortParams(currentSortParams);
  }

  async function selectedFilterProcessing() {
    let urlSmartPath = `${selectedFilterPath}${selectedFilterPath.length
      ? '/'
      : ''}`;

    let smartUrl = `${filterParams.sefDelFilterUrl}${urlSmartPath}${prepareQueryString()}`;

    updateBrowserHistory(smartUrl);

    // загрузка фильтра
    let response = await request(filterParams.asyncUrl, {
      link: selectedFilterPath,
      params: filterParams.params,
    });

    // обновление фильтра
    setFilterParams({
      ...filterParams,
      filterItems: response.ITEMS,
      globalFilter: response.GLOBAL_FILTER,
    });

    // обновление SEO параметров
    setSeoParams(response.SEO_PARAMS);

    // обновление (теги) выбранных фильтров
    setFilterTags({...filterTags, filterList: response.ACTIVE_FILTERS});

    if (isMobile && filterOpened) {
      setNeedUpdating(true);
    } else {
      // обновление списка товаров
      refreshProducts(
        response.GLOBAL_FILTER,
        state.productListParams.sectionCode,
        1, // при работе с фильтром сброс страницы
        navParams.limit,
        response.SEO_PARAMS);
    }
  }

  /**
   * Обновление списка товаров
   *
   * @param {string} filterValues - The filter values to apply.
   * @param {string} sectionCode - The section code for the product list.
   * @param {string} sort - The sorting criteria for the product list.
   * @param {string} order - The order of sorting for the product list.
   * @param {number} page - The page number for pagination.
   * @param {number} limit - The maximum number of items to display per page.
   * @param {object} seo - The SEO parameters for the product list.
   *
   * @return {void}
   */
  async function refreshProducts(
      filterValues,
      sectionCode,
      page,
      limit,
      seo,
      expand = false,
  ) {
    let sortOrder = getActualSortOrder();

    // загрузка данных списка товаров
    let response = await request(state.productListParams.asyncUrl, {
      filterValues: filterValues,
      section: sectionCode,
      sort: sortOrder.sort,
      order: sortOrder.order,
      page: page,
      limit: limit,
      seoParams: seo,
      showMore: expand,
      path: window.location.pathname
    });

    let products = [];

    if (expand) {
      products = products.concat(state.productListParams.itemsList.slice());
    }

    products = products.concat(response.ITEMS);

    setState({
      ...state,
      productListParams: {
        ...state.productListParams,
        itemsList: products,
      },
      titleBlockParams: {
        ...state.titleBlockParams,
        title: response.SEO_DATA.h1,
      },
      regionShopsParams: {
        ...state.regionShopsParams,
        title: `${state.productListParams.messages.CT_BCI_TPL_BUY} ${response.SEO_DATA.h1} ${decodeHtmlEntities(state.productListParams.messages.STORES_REGION_TITLE)}`
      },
      catalogHeight: 'auto'
    });

    // сохраняем состояние
    setNavParams({
      ...navParams,
      limit: Number(response.NAV_PARAMS.NAV_PAGE_COUNT_ITEM_LIST),
      firstPage: Number(response.NAV_PARAMS.START_PAGE),
      lastPage: Number(response.NAV_PARAMS.END_PAGE),
      page: Number(response.NAV_PARAMS.NAV_PAGE_NUMBER),
      countPages: Number(response.NAV_PARAMS.PAGER_COUNT),
    });

    setTotalProductsCount(response.TOTAL_PRODUCT_COUNT &&
    !isNaN(response.TOTAL_PRODUCT_COUNT) ?
        Number(response.TOTAL_PRODUCT_COUNT) : 0);

    setMetaParams(response.SEO_DATA);
  }

  /**
   * Makes a pagination path with the given page number.
   * @param {number} page - The page number to be included in the pagination path.
   * @return {string} - The pagination path with the specified page number.
   */
  function makePaginationPath(page) {
    let urlPath = window.location.pathname;
    let urlParts = urlPath.split('/').filter(entry => (entry.length > 0));
    let pageTemplateRegExp = /\/page=\d+\//;
    console.info('urlPath', urlPath);
    console.info('urlParts', urlParts);

    if (urlPath.search(pageTemplateRegExp) != -1) { // вхождение найдено
      urlParts = urlParts.slice(0, urlParts.length - 1);
      console.info('urlParts вхождение найдено', urlParts);
    }

    if (page > 1) {
      urlParts.push(`page=${page}`);
    }

    console.info('urlParts page', urlParts);

    return `/${urlParts.join('/')}/`;
  }

  /**
   * Updates the browser history with the provided smart URL.
   *
   * @param {string} smartUrl - The smart URL to be added to the browser history.
   *
   * @return {void}
   */
  function updateBrowserHistory(smartUrl) {

    const languageChangeElement = document.getElementById('language_change');

    if (languageChangeElement) {
      const lang = languageChangeElement.getAttribute('data-lang');
      let newSmartUrl;

      if (lang === 'ua') {
        // Удаляем '/ua' из smartUrl
        newSmartUrl = smartUrl.replace(/^\/ua/, '');
      } else {
        // Добавляем '/ua' к началу smartUrl
        newSmartUrl = `/ua${smartUrl}`;
      }

      // Обновляем href у элемента с id language_change
      languageChangeElement.href = newSmartUrl;
    }

    // добавляем текущий URL в историю
    window.history.pushState({url: smartUrl}, null, smartUrl);
  }

  /**
   * Prepares a query string based on the given redefine parameters.
   *
   * @param {Object} [redefineParams] - Redefine parameters to replace or delete in the query string.
   * @return {string} - The prepared query string.
   */
  function prepareQueryString(redefineParams = {}) {
    let parsedQueryString = queryString.parse(window.location.search);

    // замена или удаление параметров строки запроса
    for (let key in redefineParams) {
      parsedQueryString[key] = redefineParams[key];
    }

    return Object.keys(parsedQueryString).length ? '?' +
        queryString.stringify(parsedQueryString) : '';
  }

  /**
   * Retrieves the actual sort order based on the current state.
   *
   * @returns {Object} The actual sort order object.
   * @property {string} sort - The sort parameter.
   * @property {string} order - The sort order.
   */
  function getActualSortOrder() {
    // возвращаем из измененного состояния
    if (sortState !== null) return {
      sort: sortState.sort,
      order: sortState.order,
    };
    // возвращаем из базового состояния
    for (let option of sortParams.options) {
      if (!option.active) continue;
      return {sort: option.sort, order: option.order};
    }
  }

  /**
   * Scrolls the catalogRef.current element into view smoothly from the top.
   */
  function scrollTop() {
    if (!(catalogRef.current instanceof HTMLElement)) return;
    catalogRef.current.scrollIntoView({block: 'start', behavior: 'smooth'});
  }

  /**
   * Returns the word form based on a given number and forms provided.
   *
   * @param {number} number - The number to determine the word form for.
   * @param {string[]} forms - The array of word forms.
   * @return {string} The word form based on the given number and forms.
   */
  function getWordForm(number, forms) {
    const cases = [2, 0, 1, 1, 1, 2];
    return forms[
        number % 100 > 4 && number % 100 < 20 ? 2 : cases[number % 10 < 5
            ? number % 10
            : 5]
        ];
  }

  /**
   * Determines if the user is accessing the website from a mobile device.
   * {boolean} - true if the user is accessing from a mobile device, false otherwise.
   */
  const isMobile = clientWidth < 1280;

  /**
   * Sends a POST request to the specified API endpoint.
   *
   * @param {string} apiUrl - The URL of the API endpoint.
   * @param {Object} data - The data payload to be sent with the request.
   * @returns {Promise} A Promise that resolves with the response data, or null if an error occurs.
   *
   * @example
   * request('https://api.example.com/endpoint', { foo: 'bar' })
   *   .then(response => {
   *     console.log(response);
   *   })
   *   .catch(error => {
   *     console.error(error);
   *   });
   */
  function request(apiUrl, data) {
    return new Promise(resolve => {
      eventEmitter.emit('showLoader');
      axiosInstance.post(apiUrl, data).then(response => {
        eventEmitter.emit('hideLoader');
        console.info(apiUrl, 'response data', response.data);
        resolve(response.data);
      }).catch(reason => {
        console.info('request error', reason);
        eventEmitter.emit('hideLoader');
        resolve(null);
      });
    });
  }

  /**
   * Handle the "popstate" event triggered when the user navigates backwards or forwards in the browser history.
   *
   * @param {PopStateEvent} event - The event object containing information about the state change.
   * @return {void}
   */
  function onPopState(event) {
    console.info('Previous URL:', event);
    if (event.state && event.state.url) {
      window.location.href = event.state.url;
    }
  }

  /**
   * Perform actions when a property is changed. This method updates the state and triggers
   * various events based on the updated property.
   *
   * @param {string} link - The link value.
   * @return {void}
   */
  function onPropChange(selectedFilterPath = '') {
    console.info('onPropChange', selectedFilterPath);
    setSelectedFilterPath(selectedFilterPath);
  }

  /**
   * Handle the price change event by updating the selected filter path based on the given template, min, and max values.
   *
   * @param {string} template - The template string to be used for generating the smartPath. It should contain placeholders '{min}' and '{max}'.
   * @param {number} min - The minimum price value.
   * @param {number} max - The maximum price value.
   * @return {void} - No return value.
   */
  function onPriceChange(template = 'price-{min}-{max}', min, max) {
    //console.info('onPriceChange', template, min, max);
    // подготовка smartPath
    template = template.replace('{min}', min);
    template = template.replace('{max}', max);
    setSelectedFilterPath(template);
  }

  /**
   * Sets the current page to the specified page number.
   *
   * @param {number} pageNumber - The page number to set.
   * @return {void}
   */
  async function onPageChange(pageNumber) {
    //console.info('onPageChange', pageNumber);
    // пропускаем стартовое состояние
    if (pageNumber === null || isNaN(pageNumber)) return;

    // формирование нового url
    let smartUrl = `${makePaginationPath(pageNumber)}${prepareQueryString()}`;

    //console.info('smartUrl', smartUrl);

    // обновляем историю
    updateBrowserHistory(smartUrl);

    // перезагрузка списка товаров
    await refreshProducts(
        filterParams.globalFilter,
        state.productListParams.sectionCode,
        pageNumber,
        pageSize,
        seoParams,
    );

    scrollTop();
  }

  async function onShowMore(event) {
    //console.info('onShowMore', event);
    if (navParams.page >= navParams.countPages) return;

    let pageNumber = navParams.page + 1;

    // формирование нового url
    let smartUrl = `${makePaginationPath(pageNumber)}${prepareQueryString()}`;

    //console.info('smartUrl', smartUrl);

    // обновляем историю
    updateBrowserHistory(smartUrl);

    // перезагрузка списка товаров
    await refreshProducts(
        filterParams.globalFilter,
        state.productListParams.sectionCode,
        pageNumber,
        pageSize,
        seoParams,
        true,
    );
  }

  /**
   * Обработка события смены сортировки
   * Updates the sort state and performs necessary actions based on the selected sort option.
   * @async
   * @param {Object} checkedOption - The selected sort option.
   * @param {string} checkedOption.sort - The sort option to apply.
   * @param {string} checkedOption.order - The sort order to apply.
   * @returns {void}
   */
  function onSortChange(checkedOption) {
    setSortState(checkedOption);
  }

  /**
   * Обработка события смены количества показа на странице
   * @param pageSize
   */
  function onPageSizeChange(pageSize = 24) {
    setPageSize(pageSize);
  }

  /**
   * Closes the mobile filter.
   *
   * @param {Event} event - The event object passed to the function.
   * @return {void}
   */
  async function onCloseMobileFilter(event) {
    //console.info('onCloseMobileFilter', event);
    event.preventDefault();
    setFilterOpened(false);
    document.body.classList.remove('filter-open');

    if (needUpdating) {
      // перезагрузка списка товаров
      refreshProducts(
          filterParams.globalFilter,
          state.productListParams.sectionCode,
          1,
          navParams.limit,
          seoParams,
      );

      setNeedUpdating(false);
    }
  }

  /**
   * Декодирует HTML-сущности в текстовые символы.
   *
   * @param {string} text - Строка, содержащая HTML-сущности.
   * @return {string} - Строка с декодированными символами.
   */
  function decodeHtmlEntities(text) {
    const parser = new DOMParser();
    const doc = parser.parseFromString(text, 'text/html');
    return doc.documentElement.textContent;
  }

  /**
   * This function is called when the mobile filter is shown.
   * It prevents the default behavior of the event, sets the filter to opened state,
   * adds 'active' class to the background element, sets its z-index to 99,
   * and adds 'side-open' class to the body element.
   *
   * @param {Event} event - The event object.
   *
   * @return {void}
   */
  function onShowMobileFilter(event) {
    //console.info('onShowMobileFilter', event);
    event.preventDefault();
    setFilterOpened(true);
    document.body.classList.add('filter-open');
  }

  const filtersExist = filterParams.filterItems &&
      Array.isArray(filterParams.filterItems) &&
      filterParams.filterItems.length;

  const filterTitle = filterParams.messages &&
  filterParams.messages.hasOwnProperty('CT_BCSF_FILTER_FILTERS') ?
      filterParams.messages.CT_BCSF_FILTER_FILTERS : '';

  const selectedFilterValuesCount = filterTags.filterList &&
  Object.keys(filterTags.filterList).length ?
      Number(Object.keys(filterTags.filterList).length) : 0;

  return (
      <>
        <div className={'catalog-section'}>
          <div className={'container'}>
            <Breadcrumbs breadcrumbs={state.breadcrumbs}
                         className={'category-page'}/>
            <Title {...state.titleBlockParams}
                   getWordForm={getWordForm}
                   totalProductCount={totalProductsCount}
                   messages={state.productListParams.messages}/>
            {
                state.banner && Object.keys(state.banner).length > 0 && (
                    <Banner {...state.banner}/>
                )
            }
            {
                state.sectionDescription &&
                Object.keys(state.sectionDescription).length > 0 && (
                    <SectionDescription {...state.sectionDescription}/>
                )
            }
            {
                state.filterCloud &&
                Object.keys(state.filterCloud).length > 0 && (
                    <FilterCloud filters={state.filterCloud}
                                 onPropChange={onPropChange}/>
                )
            }
            {
                state.subSectionList &&
                Object.keys(state.subSectionList).length > 0 && (
                    <SubSectionList sections={state.subSectionList}/>
                )
            }
            <SelectionBlock clientWidth={clientWidth}>
              {
                selectedFilterValuesCount > 0 && !isMobile ?
                  <FilterTags {...filterTags}
                              messages={filterParams.messages}
                              onPropChange={onPropChange}/> :
                  <></>
              }
                <Sorting {...sortParams}
                         onChange={onSortChange}
                         isMobile={isMobile}
                         selectedFiltersExist={selectedFilterValuesCount > 0}/>
                {
                  isMobile ?
                      <button type={'button'} onClick={onShowMobileFilter}>
                        <span>{filterTitle}</span>
                        {
                          selectedFilterValuesCount > 0 ?
                              <span className="selected-filters__counter">
                              {selectedFilterValuesCount}
                            </span> :
                              <></>
                        }
                      </button> :
                          <></>
                }
            </SelectionBlock>
            <div className={'catalog no-border'} ref={catalogRef}>
              {
                filtersExist && isMobile && filterOpened ?
                    <div className={'filter-backdrop'}
                         onClick={onCloseMobileFilter}
                         onScroll={event => event.preventDefault()}/> :
                    <></>
              }
              {
                filtersExist ?
                    <Filter {...filterParams}
                            totalProductsCount={totalProductsCount}
                            totalProductsCountMessage={getWordForm(
                                totalProductsCount, [
                                  state.productListParams.messages.CATEGORY_PRODUCTS,
                                  state.productListParams.messages.CATEGORY_PRODUCTS_2,
                                  state.productListParams.messages.CATEGORY_PRODUCTS_3])}
                            opened={filterOpened}
                            needUpdating={needUpdating}
                            filterTags={filterTags}
                            selectedFiltersExist={selectedFilterValuesCount > 0}
                            isMobile={isMobile}
                            onClose={onCloseMobileFilter}
                            onChange={onPropChange}
                            onPriceChange={onPriceChange}/> :
                    <div className="filter-section empty"></div>
              }
              <div
                  className={`catalog-holder lvl-2 ${!filtersExist
                      ? 'catalog-holder-no-filter'
                      : ''} ${!isNaN(state.catalogHeight) && isMobile ? 'position-absolute' : ''}`}
                  style={isMobile && Object.keys(state.productListParams.itemsList).length !==
                  0 ? { minHeight: state.catalogHeight } : {}} >
                <ProductList {...state.productListParams}/>
                {
                    !isFilterUsed && state.categoryNewsParams &&
                    Object.keys(state.categoryNewsParams).length > 0 &&
                    Object.keys(state.productListParams.itemsList).length ===
                    0 &&
                    isCategoryNewsRendered &&
                    (
                        <>
                          <Articles {...state.categoryNewsParams}/>
                        </>
                    )
                }
                {
                  navParams.countPages > 1 || navParams.lastPage > 1 ?
                    <Pagination {...navParams}
                                clientWidth={clientWidth}
                                messages={navMessages}
                                onShowMore={onShowMore}
                                onPageSizeChange={onPageSizeChange}
                                onPageChange={onPageChange}/> : <></>
                }

              </div>
            </div>
          </div>
        </div>
        {
          Number(navParams.page) === 1 ?
            <>
              {
                state.relatedLinks &&
                state.relatedLinks.length > 0 ?
                  <RelatedLinks
                    items={state.relatedLinks}
                    title={state.productListParams.messages?.RELATED_LINKS_TITLE || ''}/> :
                  <></>
              }

              {
                state.productViewed &&
                Object.keys(state.productViewed.itemsList).length > 0 && (
                  <section className="section viewed-products-section">
                    <div className="container">
                      <div className="viewed-products viewed_products_js">
                        <Viewed {...state.productViewed} variant="catalog"/>
                      </div>
                    </div>
                  </section>
                )
              }

              {
                state.seoText ?
                  <SeoText text={state.seoText} opened={true}/> :
                  <></>
              }

              {
                state.faqParams && Object.keys(state.faqParams).length > 0 &&
                <div className={'container section content-page'}>
                  <div className={'content content-page-holder'}>
                    <Faq {...state.faqParams}/>
                  </div>
                </div>
              }
              <section className={'section content-page'}>
                <div className={'container'}>
                  {state.priceTable.items &&
                    Object.keys(state.priceTable).length > 0 && (
                      <PriceTable {...state.priceTable} messages={state.productListParams.messages}/>
                    )}
                </div>
              </section>
              <section className={'section content-page'}>
                <div className={'container'}>
                  {state.creditTable &&
                    Object.keys(state.creditTable).length > 0 && (
                      <CreditTable {...state.creditTable}/>
                    )}
                </div>
              </section>

              <section className="section content-page shops-list">
                <div className="container">
                  <Shops {...state.regionShopsParams}/>
                </div>
              </section>

              {
                state.reviews &&
                Object.keys(state.reviews.products).length > 0 &&
                Object.keys(state.reviews.category).length > 0 && (
                  <Reviews {...state.reviews}/>
                )
              }
              {
                !isFilterUsed && state.categoryNewsParams &&
                Object.keys(state.categoryNewsParams).length > 0 &&
                !isCategoryNewsRendered &&
                (<Articles {...state.categoryNewsParams}
                           clientWidth={clientWidth}/>)
              }
            </> :
            <></>
        }
      </>
  );
}


// Esputnik Tracker
let categoryId = (document.querySelector('[data-section]'))
    ? document.querySelector('[data-section]').dataset.section
    : null;

// Esputnik Tracker
eventEmitter.on('EsputnikLoaded', () => {
  esputnikTracker.CategoryPage(categoryId);
});